import(/* webpackMode: "eager" */ "/vercel/path0/app/regulations/page.tsx");
